module.exports = __webpack_public_path__ + "img/twitter.c57990c5.svg";